export enum SubClass {
    OPERANDO = 1,
    INFRAESTRUTURA = 2,
    ATRASO_INTERNO = 3,
    IMPEDIMENTO_EXTERNO = 4,
    CORRETIVA = 5,
    PREVENTIVA = 6
}